import Vue from 'vue';
import Vuex from 'vuex';
import manageUsers from './store/manage-users.js';
import saveQuestionModel from './store/save-question-model.js';
import getPersons from './store/get-persons';
import salesforceUserForm from './store/salesforce-user-form';
import accessRequests from './store/access-requests';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    manageUsers,
    salesforceUserForm,
    saveQuestionModel,
    getPersons,
    accessRequests,
  },
  state: {
    loading: true,
  },
  getters: {
    loading: state => {
      return state.loading;
    },
  },
  mutations: {
    loading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    dirtySurvey({ commit }, validationsType) {
      if (validationsType.includes('person')) {
        commit('dirtyPersonSurvey', true);
      }
    },
    handleError({ commit }, { vm, error, message }) {
      let title;
      if (error instanceof TypeError) {
        title = `Something went wrong, please contact support.`;
      } else if (error instanceof Error && error.response.status === 401) {
        title = `Error code: ${error.response.status}`;
        alert('Your session seems to have ended, please refresh');
      } else {
        title = `Error code: ${error.response.status}`;
      }
      vm.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 10000,
        toaster: 'b-toaster-top-center',
        appendToast: true,
        variant: `danger`,
      });
      console.error(error);
    },
    async exportExcel({}, payload) {
      try {
        await axios
          .post('/api/export-excel', payload, { responseType: 'blob' })
          .then(function(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${payload[payload.length - 1]['fileName']}.xlsx`);
            document.body.appendChild(link);
            link.click();
          });
      } catch (error) {
        console.log(error);
        alert(`Something went wrong, please try again later`);
      }
    },
  },
});
